// extracted by mini-css-extract-plugin
module.exports = {"videoEditor":"AdminMessageEdit_videoEditor__rzFNC","entitySelector":"AdminMessageEdit_entitySelector__MX1xK"};